<template>
  <div id="system-manage-authority-add">
    <ipub-model
      :title="params.id ? 'Edit Role' : 'Create A New Role'"
      width="600px"
      :visable="isVisable"
      @confirm="confirm"
      @cancel="cancel"
    >
      <ipub-form ref="manage-authority-add-journal-form" :model="params" :rules="rules">
        <ipub-form-item prop="journalId" label="Journal">
          <ipub-select v-model="params.journalId" placeholder="Select Journal">
            <ipub-select-option
              v-for="(item, index) in journalList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.fullName }}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>
        <ipub-form-item prop="name" label="Role Name">
          <ipub-input
            placeholder="Enter role name"
            v-model.trim="params.name"
          />
        </ipub-form-item>

        <ipub-form-item prop="roleId" label="Copy Role">
          <ipub-select
            placeholder="Please select the role to copy"
            :clear="true"
            search
            @search="getRoleList"
            v-model="params.roleId"
          >
            <ipub-select-option
              v-for="item in roleList"
              :key="item.id"
              :value="item.id"
              >{{ (item.journal ? item.journal.name : '') + ' ' + item.name }}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import role from '@/api/role'
import journal from '@/api/journal'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {},
      rules: {},
      journalList: [],
      roleList: [],
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
    }),
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {}
        this.getRoleList()
      }
    },
  },
  mounted() {
    this.getRules()
    this.getJournal()
  },
  methods: {
    async getJournal() {
      this.journalList = await journal.getAll()
    },
    async getRoleList(val) {
      this.roleList = await role.get({
        name: val,
        outSided: false,
      })
    },
    async confirm(val) {
      const flag = this.$refs['manage-authority-add-journal-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          released: val,
        })
        await role.addJournal(data)
        this.$message.success({
          title: 'Success',
          content: 'This Department has been saved!',
        })
        this.$emit('confirm', data)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    getRules() {
      this.rules = {
        name: [
          {
            required: true,
            message: 'Role Name' + this.LANGUAGE[this.language].noEmpty,
            trigger: ['blur', 'change'],
          },
          {
            max: 50,
            message: 'Role Name must not exceed 50',
            trigger: ['blur', 'change'],
          },
        ],
        journalId: [
          {
            required: true,
            message: 'Journal ' + this.LANGUAGE[this.language].noEmpty,
            trigger: ['blur', 'change'],
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#system-banners-add {
  .upload-content {
    height: 180px;
    width: 280px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
